import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { ENVIRONMENT } from '@ot/shared/model';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import {
  Environment,
  EnvironmentConfigService,
  PlatformServiceName
} from '../environment';
import { APILabelList, Label, LabelDefinition } from '../models/label';
import { CreateNotification } from '../store';
import { UserService } from '../user';

@Injectable({ providedIn: 'root' })
export class LabelsService {
  apiUrl: string;
  businessAccountId: string;
  labelCreatedSource = new Subject<boolean>();
  labelCreated$ = this.labelCreatedSource.asObservable();

  constructor(
    @Inject(ENVIRONMENT) private environment: Environment,
    private environmentConfigService: EnvironmentConfigService,
    private http: HttpClient,
    private userService: UserService,
    private store: Store<{}>
  ) {
    this.apiUrl =
      this.environmentConfigService.getEnvironmentConfigs().apis.platform.url +
      '/' +
      'business-acct-service/v2';
    /*this.environment.serviceUrlList[
        PlatformServiceName.BusinessAccountService
      ];*/
    this.businessAccountId = this.userService.getBusinessAccount();
  }

  getLabelsList(): Observable<LabelDefinition[]> {
    const baidToUse = localStorage.getItem('selectedBaid') || this.businessAccountId;
    const url = `${this.apiUrl}/businessAcct/labels?businessAccountUuid=${baidToUse}`;

    return this.http
      .get<APILabelList>(url)
      .pipe(map(labelsList => labelsList.labelDefinitions));
  }

  createLabel(label: Label): Observable<any> {
    const { key, value } = label;
    const body = {
      businessAccountUuid: this.businessAccountId,
      labelDefinition: {
        id: null,
        key,
        value
      }
    };

    return this.http
      .post<LabelDefinition>(this.apiUrl + '/businessAcct/labels/create', body)
      .pipe(
        catchError(error => {
          if (error.status === 409) {
            this.store.dispatch(
              new CreateNotification(
                `Label "${(
                  value || key
                ).toUpperCase()}" already exists or is greater than 63 characters.`
              )
            );
            return null;
          } else {
            throw error;
          }
        })
      );
  }

  notifyLabelWasCreated() {
    this.labelCreatedSource.next(true);
  }
}
